import axios from 'axios';

export const tncManagementApi = {
    getTnc,
    uploadTnc,
    updateTnc,
    deleteTnc,
    previewTnc
  };

async function getTnc() {
    const url = process.env.VUE_APP_API_BASEURL + 'tnc';

    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')

    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching TNC:", error);
        throw error;
    }
}

async function uploadTnc(file) {
    const url = process.env.VUE_APP_API_BASEURL + 'tnc/upload';

    const formData = new FormData();
    formData.append('file', file);

    const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + localStorage.getItem('jwt')
    };

    try {
        const response = await axios.post(url, formData, { headers });
        return response;
    } catch (error) {
        console.error("Error uploading TNC:", error);
        throw error;
    }
}

async function updateTnc(file, tncId) {
    const url = process.env.VUE_APP_API_BASEURL + 'tnc/update/' + tncId;

    const formData = new FormData();
    formData.append('file', file);

    const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + localStorage.getItem('jwt')
    };

    try {
        const response = await axios.post(url, formData, { headers });
        return response;
    } catch (error) {
        console.error("Error updating TNC:", error);
        throw error;
    }
}

async function deleteTnc(tncId) {
    const url = process.env.VUE_APP_API_BASEURL + 'tnc/delete/' + tncId;

    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
    
    try {
        const response = await axios.delete(url);
        return response;
    } catch (error) {
        console.error("Error deleting TNC:", error);
        throw error;
    }
}

async function previewTnc(tncId) {
    const url = process.env.VUE_APP_API_BASEURL + 'tnc/preview-file/' + tncId;

    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')

    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error preview TNC:", error);
        throw error;
    }
}


